// extracted by mini-css-extract-plugin
export var measureBox = "_cv-0";